import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import Preloader from '../../components/preloader';
import Alert from '../../components/alert';
import Header from '../../components/header';

export default function Updatemarks() {
    const [data, setData] = useState(null);
    const [sessionals, setsessionals] = useState({});
    const [alertVisible, setAlertVisible] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [semesters, setSemesters] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [sessionalsubjects, setSessionalSubjects] = useState([]);

    useEffect(() => {
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;
        
        getDocs(collection(db, 'institutions', loggedUser.institution_id, 'marks')).then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data());
            const semesterKeys = [...new Set(data.map(m => m.semester))];
            setSemesters(semesterKeys);
        });
    }, []);

    useEffect(() => {
        if (selectedSemester) {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) return;
            
            const q = query(
                collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
                where('semester', '==', selectedSemester)
            );
            getDocs(q).then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data());
                setSessionalSubjects(data);
            });
        }
    },
        [selectedSemester]);

    useEffect(() => {
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;
        
        const q = query(
            collection(db, 'institutions', loggedUser.institution_id, 'students'),
            where('teacher_id', '==', loggedUser.id)
        );
        getDocs(q).then(snapshot => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setData(data);
        });
    }, []);

    const checksubject = (key) => {
        // eslint-disable-next-line no-useless-escape
        return key.replace(/[./#$\[\]]/g, '_');
    };

    const handlesessionalsChange = (subject, id, value) => {
        const checkedsub = checksubject(subject);
        setsessionals((prev) => ({
            ...prev,
            [id]: {
                ...(prev[id]),
                FinalMarks: {
                    [selectedSemester]: {
                        ...(prev[id]?.FinalMarks?.[selectedSemester]),
                        [checkedsub]: value,
                    }
                }
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
            if (!loggedUser || !loggedUser.institution_id) {
                throw new Error('Session expired. Please login again.');
            }
            
            if (!data || data.length === 0) {
                throw new Error('No students found to update marks.');
            }
            
            // Batch update marks for all students
            for (const student of data) {
                const studentRef = doc(db, 'institutions', loggedUser.institution_id, 'marks', student.id);
                await updateDoc(studentRef, {
                    semester: selectedSemester,
                    finalMarks: sessionals[student.id]?.FinalMarks?.[selectedSemester] || {}
                });
            }

            setAlertVisible(true);
            setTimeout(() => setAlertVisible(false), 3000);
            setTimeout(() => window.location.reload(), 3500);
        } catch (error) {
            console.error("Error updating marks:", error);
            setError(`❌ ${error.message || 'Failed to update marks. Please try again.'}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Header title="Update Final Marks" />
            <section className="col-12 pt-5">
                <div className="row justify-content-center">

                    {alertVisible && <Alert message="Form submitted successfully!" />}
                    {loading && <Preloader />}
                    {error && <Alert message={error} type="Error" color="error" />}
                    <div className="form-group form-floating col-5 ms-3">
                        <select aria-label="Floating label select example" required id="semester" className="form-select" value={selectedSemester} onChange={(e) =>
                            setSelectedSemester(e.target.value)
                        }>
                            <option value="" selected>
                                -----------
                            </option>
                            {semesters.map((semester) => (
                                <option key={semester} value={semester}>
                                    {semester}
                                </option>
                            ))}
                        </select>
                        <label htmlFor="floatingSelect">Select Semester:</label>
                    </div>

                    <form onSubmit={handleSubmit} className="col-10 mt-4">
                        <div className="row justify-content-center ms-3">
                            {selectedSemester ? <table className="table table-hover table-responsive">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Roll No</th>
                                        {Object.values(sessionalsubjects).map((sub) => (

                                            <th key={sub.id}>{sub.subject}</th>
                                        )
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data ? (
                                        Object.keys(data).map((key, index) => (
                                            <tr key={key.id}>
                                                <td>{index + 1}</td>
                                                <td>{data[key].Name}</td>
                                                <td>{data[key].rollNo}</td>
                                                {Object.values(sessionalsubjects).map((sub) => (
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e) =>
                                                                handlesessionalsChange(sub.subject, key, e.target.value)
                                                            }

                                                        />
                                                    </td>
                                                ))}

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                Loading data...
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <button type="submit" className="btn btn-outline-danger offset-1 ">
                                    Submit
                                </button>
                            </table>
                                : null}
                        </div>
                    </form>
                </div>
            </section>
        </Layout >
    );
}
